import { createActionGroup, props } from '@ngrx/store';
import { Location, Room } from '@rocksoft/locations-sdk';
import { CategoryType, ErrorModel } from '@rocksoft/shared';
import { CategoriesUnion } from './category.state';

// ============================================================================
// RESOLVER ACTIONS
// ============================================================================

export const CategoryResolverActions = createActionGroup({
  source: 'Category Resolver',
  events: {
    'Categories requested': props<{ categoryType: CategoryType; parentCategoryId?: string }>(),
  },
});

export const CategoryLoadActions = createActionGroup({
  source: 'Category load',
  events: {
    'Assignable children requested': props<{ locationCategoryId: string }>(),
    'Unavailable category requested': props<{ brandCategoryId: string }>(),
  },
});

// ============================================================================
// API ACTIONS
// ============================================================================

export const CategoryApiActions = createActionGroup({
  source: 'Category API',
  events: {
    'Categories loaded': props<{
      configurations: CategoriesUnion[];
      categoryType?: CategoryType;
      parentCategoryId?: string;
    }>(),
    'Categories loaded error': props<{
      error: ErrorModel;
      categoryType?: CategoryType;
      parentCategoryId?: string;
    }>(),
    'Category added': props<{ configuration: CategoriesUnion; originalConfiguration?: CategoriesUnion }>(),
    'Category added error': props<{ configuration: CategoriesUnion; error: ErrorModel }>(),
    'Category updated': props<{ configuration: CategoriesUnion }>(),
    'Category updated error': props<{
      originalConfiguration: CategoriesUnion;
      configuration: CategoriesUnion;
      error: ErrorModel;
    }>(),
    'Category deleted': props<{ configuration: CategoriesUnion }>(),
    'Category deleted error': props<{ configuration: CategoriesUnion; error: ErrorModel }>(),
    'Status changed': props<{ categoryType: CategoryType; categoryId: string; status: boolean }>(),
    'Status changed error': props<{ categoryType: CategoryType; categoryId: string; error: ErrorModel }>(),
  },
});

// ============================================================================
// VIEW ACTIONS
// ============================================================================

export const CategoryViewActions = createActionGroup({
  source: 'Category View',
  events: {
    'Category added': props<{ entity: CategoriesUnion }>(),
    'Category updated': props<{ originalEntity: CategoriesUnion; entity: CategoriesUnion }>(),
    'Category deleted': props<{ entity: CategoriesUnion }>(),
  },
});

// ============================================================================
// LIST ACTIONS
// ============================================================================

export const CategoryListActions = createActionGroup({
  source: 'Category list',
  events: {
    'Category added': props<{ entity: CategoriesUnion }>(),
    'Category deleted': props<{ entity: CategoriesUnion }>(),
    'Category updated': props<{ originalEntity: CategoriesUnion; entity: CategoriesUnion }>(),
  },
});

// ============================================================================
// GEO LOCATIONS ACTIONS
// ============================================================================

export const CategoryGeoLocationsActions = createActionGroup({
  source: 'Geo location',
  events: {
    'Category updated': props<{ originalEntity: CategoriesUnion; entity: CategoriesUnion }>(),
  },
});

// ============================================================================
// STATUS ACTIONS (Room-specific: check in/out)
// ============================================================================

export const CategoryStatusContainerActions = createActionGroup({
  source: 'Category status container',
  events: {
    'Status changed': props<{ room: Room; status: boolean }>(),
  },
});

// ============================================================================
// SIGNALR HUB ACTIONS (Room-specific: SignalR updates)
// ============================================================================

export const CategorySignalRHubActions = createActionGroup({
  source: 'Category SignalR Hub',
  events: {
    'Category updated': props<{ categoryType: CategoryType; categoryId: string; status: 'CheckedIn' | 'CheckedOut' }>(),
  },
});

// ============================================================================
// SIGNALR HUB ACTIONS (category updates)
// ============================================================================

export const LocationsSignalRHubActions = createActionGroup({
  source: 'Locations SignalR Hub',
  events: {
    'Location updated': props<{ location: Location }>(),
    'Room updated': props<{ room: Room }>(),
    'Category deleted': props<{ categoryType: CategoryType; categoryId: string }>(),
  },
});
